import { Map } from 'immutable';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import bannerConfig from './config';

export default class BannerList extends PureComponent {
  static propTypes = {
    user: PropTypes.instanceOf(Map).isRequired,
    bannerList: PropTypes.instanceOf(Map).isRequired,
    closeWriteOffMessage: PropTypes.func.isRequired,
    closeBanner: PropTypes.func.isRequired,
    closeBannerRequest: PropTypes.func.isRequired,
    getBanners: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { bannerList, getBanners } = this.props;

    if (!bannerList.get('data') && !bannerList.get('loading') && !bannerList.get('error')) {
      getBanners();
    }
  }

  closeWriteOffMessage(key) {
    const { closeWriteOffMessage } = this.props;
    closeWriteOffMessage(key);
  }

  closeSystemMessage(key) {
    const { closeBanner, closeBannerRequest } = this.props;
    closeBanner(key);
    closeBannerRequest(key);
  }

  getBannerContent = (banner) => {
    const { user } = this.props;
    return typeof banner.content === 'function' ? banner.content(user) : banner.content;
  };

  getBannerList() {}

  renderBannerConfig = () => {
    const { user } = this.props;

    return bannerConfig.map((banner, key) => {
      const needShow = user.getIn(['data', banner.name]);

      if (!needShow) {
        return null;
      }

      return (
        <div
          key={`banner_${key}`}
          className="header-message js-header-message header-message__border"
        >
          <div className="content">
            <div className="header-message_block">
              {this.getBannerContent(banner)}
              <div
                onClick={() => this.closeWriteOffMessage(banner.name)}
                className="icon icon_close js-header-message-btn"
              >
                <span className="replace_text">Закрыть</span>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  renderBannerList = () => {
    const { bannerList } = this.props;
    const bannerListData = bannerList.get('data');

    if (!bannerListData.length) {
      return [];
    }

    return bannerListData.map((banner) => {
      if (banner.isClosed) {
        return null;
      }
      return (
        <div
          key={`banner_system_${banner.messageId}`}
          className="header-message js-header-message header-message__border"
        >
          <div className="content">
            <div className="header-message_block">
              <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{ __html: banner.messageText }}
              />
              {banner.isClosable ? (
                <div
                  onClick={() => this.closeSystemMessage(banner.messageId)}
                  className="icon icon_close js-header-message-btn"
                >
                  <span className="replace_text">Закрыть</span>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      );
    });
  };

  render() {
    const { bannerList } = this.props;
    const banners = this.renderBannerConfig();

    if (bannerList.get('data')) {
      banners.push(...this.renderBannerList());
    }

    return banners;
  }
}
